import { CaseSchedulesAlertButton } from '@/pages/ui/case-scheduled-alert-button/case-scheduled-alert-button'

import { Card, CardContent, CardHeader, CardTitle } from '@/components/card/card'

import { type ClientPortalCaseAlertItem } from '@/lib/queries/case-dashboard/types'
import { cn } from '@/lib/utils'

export interface ScheduledAlertsCardProps {
  scheduledAlertsData?: ClientPortalCaseAlertItem[]
}

export const ScheduledAlertsCard = ({ scheduledAlertsData }: ScheduledAlertsCardProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className={cn('text-lg font-semibold text-black')}>Scheduled Alerts</CardTitle>
      </CardHeader>
      <CardContent>
        {!scheduledAlertsData && (
          <div
            className={cn(
              'text-center text-sm font-normal text-foreground',
              'px-4 py-5',
              'rounded-[10px]',
              'bg-elevated'
            )}
          >
            No alert data.
          </div>
        )}
        {scheduledAlertsData?.map(({ alertType, deadline, notificationTime }, index) => (
          <CaseSchedulesAlertButton
            key={`${alertType}-${deadline}-${notificationTime}-${index}`}
            order={index}
            alertType={alertType}
            deadline={deadline}
            notificationTime={notificationTime}
            noninteractive
            className={cn('w-full')}
          />
        ))}
      </CardContent>
    </Card>
  )
}
